<template>
  <template
    v-for="(item, index) in children_list"
    :key="index"
  >
    <template v-if="item?.children && item.children.length > 0">
      <a-sub-menu
        :key="index"
        :title="item.name"
        :disabled="item.disabled"
      >
        <head-btn-children
          :children_list="item.children"
          :selected-row-keys="selectedRowKeys"
          :dataSource="dataSource"
          :current_org="current_org"
          :handleBtnClick="handleBtnClick"
        />
      </a-sub-menu>
    </template>
    <template v-else>
      <a-menu-item
        :key="index"
        :disabled="item.disabled"
        @click="
          () => {
            handleBtnClick(item, {
              dataSource: dataSource,
              selectedRowKeys: selectedRowKeys,
              current_org: current_org,
            });
          }
        "
      >
        {{ item.name }}
      </a-menu-item>
    </template>
  </template>
</template>
<script lang="ts">
import { HeadBtnListConfig } from 'liyu-pc-base/api/typing';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'HeadBtnChildren',
  props: {
    children_list: {
      type: Array as PropType<HeadBtnListConfig>,
      required: true,
    },
    selectedRowKeys: {
      type: Array as PropType<any[]>,
      required: true,
    },
    dataSource: {
      type: Array as PropType<any[]>,
      required: true,
    },
    current_org: {
      type: Object as PropType<any>,
      required: true,
    },
    handleBtnClick: {
      type: Function as PropType<any>,
      required: true,
    },
  },
  setup(props) {
    return {};
  },
});
</script>
